import type { CSSProperties, ReactNode } from 'react';

export interface BadgeProps {
  variant?: 'count' | 'status' | 'label';
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'error';
  children?: ReactNode;
  className?: string;
}

const colorMap = {
  primary: '#00e5a0',
  secondary: '#ff6b9d',
  success: '#34d399',
  warning: '#fbbf24',
  error: '#f87171',
} as const;

export function Badge({ variant = 'label', color = 'primary', children, className }: BadgeProps) {
  const bg = colorMap[color];
  const isCount = variant === 'count';
  const isStatus = variant === 'status';

  const style: CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: isCount ? 11 : 12,
    fontWeight: 600,
    lineHeight: 1,
    color: color === 'primary' || color === 'success' ? '#050508' : '#ffffff',
    backgroundColor: bg,
    borderRadius: isCount ? 9999 : isStatus ? 9999 : 6,
    padding: isCount ? '2px 6px' : isStatus ? '4px 10px' : '4px 10px',
    minWidth: isCount ? 20 : undefined,
    letterSpacing: '0.02em',
  };

  if (isStatus) {
    style.fontSize = 11;
    style.textTransform = 'uppercase';
    style.letterSpacing = '0.06em';
  }

  return (
    <span data-variant={variant} data-color={color} className={className} style={style}>
      {children}
    </span>
  );
}
